import type { FC } from 'react';
import { useTheme } from 'styled-components';
import type { IIconsProps } from './types';
import { IconScale } from './types';

const FileSearchLine: FC<IIconsProps> = ({
  color,
  size = IconScale.M,
}: IIconsProps) => {
  const theme = useTheme();
  if (!color) {
    color = theme.palette.primary.main;
  }
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 5.33366H6.66667V26.667H25.3333V10.667H20V5.33366ZM4 3.98939C4 3.25906 4.59665 2.66699 5.33133 2.66699H21.3333L27.9996 9.33366L28 27.9903C28 28.7322 27.4068 29.3337 26.6755 29.3337H5.32453C4.59301 29.3337 4 28.7266 4 28.0113V3.98939ZM18.0387 19.2622C15.9935 20.4702 13.3151 20.1955 11.5579 18.4382C9.47507 16.3554 9.47507 12.9786 11.5579 10.8958C13.6407 8.81297 17.0175 8.81297 19.1003 10.8958C20.8576 12.653 21.1323 15.3314 19.9243 17.3766L22.8716 20.3238L20.986 22.2095L18.0387 19.2622ZM17.2147 16.5526C18.2561 15.5113 18.2561 13.8227 17.2147 12.7814C16.1733 11.74 14.4849 11.74 13.4435 12.7814C12.4021 13.8227 12.4021 15.5113 13.4435 16.5526C14.4849 17.5941 16.1733 17.5941 17.2147 16.5526Z"
        fill={color}
      />
    </svg>
  );
};

export default FileSearchLine;
